<template>
    <div class="principal">
        <NavBar :usarAberto="true" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
            :usarRelatorio="false" :usarFiltroSetor="false" :usarFiltroTpChamado="false" :usarFiltroPosicao="false"
            :formatarDataInicioMes="formatarDataInicioMes" />

        <CardLeito :campos="pCampos" :titulo="pTitulo" :cabecalho="cabecalho" :linhas="linhas" />


        <ModalEditar :mostrar="this.comMensagem" class="modal" :tamanhoModal="50">
            <template v-slot:header>
                <h2>Aviso</h2>
            </template>
            <template v-slot:corpo>
                <p>{{ this.mensagem }}</p>
            </template>
            <template v-slot:rodape>
                <div class="footer align-items-left">
                    <button @click="fechar" class="btn btn-secondary">Fechar</button>
                </div>
            </template>
        </ModalEditar>

    </div>
</template>

<script setup>
import api from '@/api/api';
import CardLeito from '@/components/CardLeito.vue';
import store from '@/store/store';
import ModalEditar from '@/components/ModalEditar.vue';
import NavBar from '@/components/NavBar.vue';
import router from '@/roteador/indexRoteador';
import { reactive, onMounted, computed, defineProps } from 'vue';

onMounted(() => {
    preecheCabecalho();
});

const state = reactive({
    cabecalho: [],
    linhas: [],
    mensagem: String(),
    comMensagem: Boolean()
});

const props = defineProps(['pCabecalho', 'pTitulo', 'pCampos', 'formatarDataInicioMes']);

async function gerarGrid() {
    let dados;
    dados = await api.listarLeitoComChamado();
    if (dados && dados.length > 0) {
        dados.forEach(dado => {
            console.log(dado);
        });

    }
}

function preecheCabecalho() {
    let cab = props.pCabecalho;
    cab.split(',').forEach((cab, i) => {
        let elemento = cab.split('|');
        state.cabecalho.push({ id: i++, nome: elemento[0], titulo: elemento[1] });
    });
}

function iniciar() {
    api.listarLeitoComChamado()
        .then(resposta => {
            state.leitos = resposta;
        })
        .catch(erro => {
            console.log(erro);
        });
}

function voltar() {
    router.back();
}

function deslogar() {
    sessionStorage.removeItem("TokenReguaPainel");
    router.back();
}

function cronometro() {
    setTimeout(() => {
        setInterval(() => {
            iniciar();
        }, 6000 * config.value.atualizacao
        );
    }, 2000);
}

const config = computed(() => {
    return store.state.config;
});
</script>

<style scoped></style>